import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function formatDate(date: string | Date | null | undefined) {
	if (!date) {
		return "Unknown date";
	}

	const dateObj = new Date(date);
	if (isNaN(dateObj.getTime())) {
		return "Invalid date";
	}

	return new Intl.DateTimeFormat("en-US", {
		year: "numeric",
		month: "long",
		day: "numeric",
	}).format(dateObj);
}

export function formatRelativeDate(date: string | Date | null | undefined) {
	if (!date) {
		return "Unknown time";
	}

	const now = new Date();
	const targetDate = new Date(date);

	if (isNaN(targetDate.getTime())) {
		return "Invalid date";
	}

	const diffInMs = now.getTime() - targetDate.getTime();
	const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

	if (diffInDays === 0) return "Today";
	if (diffInDays === 1) return "Yesterday";
	if (diffInDays < 7) return `${diffInDays} days ago`;
	if (diffInDays < 30) return `${Math.floor(diffInDays / 7)} weeks ago`;
	return formatDate(date);
}

export function calculateProgress(current: number, total: number): number {
	return Math.round((current / total) * 100);
}

export function generateId(): string {
	return crypto.randomUUID();
}
